var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitResponse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 133,
    viewBox: "0 0 202 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M39.2052 21.192C-7.04251 41.653 -19.2362 126.891 42.6856 132.182C70.3746 134.546 81.6889 106.501 107.743 99.137C132.205 92.217 150.224 113.62 176.267 94.595C206.951 72.204 217.949 10.254 177.066 1.44278C159.264 -2.39512 150.305 14.8032 134.127 17.0173C101.331 21.5103 73.5682 5.99829 39.2052 21.192Z",
    fill: "#4E84A1",
    fillOpacity: 0.09
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.999 21.0072L174.388 83.751C174.736 85.39 174.421 87.099 173.51 88.505C172.599 89.911 171.168 90.898 169.531 91.25L50.0337 116.752C48.3956 117.098 46.6873 116.781 45.2821 115.871C43.877 114.961 42.8892 113.531 42.5348 111.895L29.136 49.151C28.7907 47.511 29.1091 45.802 30.0214 44.396C30.9336 42.991 32.3656 42.004 34.0037 41.652L153.501 16.1497C155.14 15.8044 156.85 16.1228 158.255 17.0351C159.661 17.9474 160.647 19.3793 160.999 21.0174V21.0072Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.055 16.8971L118.132 65.908C114.429 70.452 109.286 73.596 103.554 74.82C97.822 76.044 91.843 75.274 86.608 72.638L30.1484 44.201C31.0619 42.889 32.4404 41.973 34.0042 41.641L153.501 16.1381C155.06 15.8063 156.688 16.0775 158.055 16.8971Z",
    fill: "#4E84A2",
    fillOpacity: 0.58
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.361 105.709C175.838 107.867 185.271 101.933 187.428 92.455C189.586 82.977 183.652 73.545 174.175 71.387C164.697 69.229 155.264 75.163 153.107 84.641C150.949 94.119 156.883 103.551 166.361 105.709Z",
    fill: "#59B855"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.687 86.594L165.451 84.39L168.843 89.275L179.064 83.33L181.473 86.9L167.463 95.13L161.687 86.594Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitResponse);
export default __webpack_public_path__ + "static/media/submit-response.daeef5fedd67652519956c2c5469b445.svg";
export { ForwardRef as ReactComponent };